export const notificationConstants = {
    LOAD_REQUEST: 'NOTIFICATIONS_LOAD_REQUEST',
    LOAD_SUCCESS: 'NOTIFICATIONS_LOAD_SUCCESS',
    LOAD_FAILURE: 'NOTIFICATIONS_LOAD_FAILURE',
    MARK_VIEWED: 'NOTIFICATIONS_MARK_VIEWED',
    HYDRATE_VIEWED_AT: 'NOTIFICATIONS_HYDRATE_VIEWED_AT',
    UNREAD_COUNT_SUCCESS: 'NOTIFICATIONS_UNREAD_COUNT_SUCCESS',
    MARK_ONE_READ: 'NOTIFICATIONS_MARK_ONE_READ',
    MARK_ALL_READ: 'NOTIFICATIONS_MARK_ALL_READ',
};
